import React, { Component } from 'react'
import Link from 'gatsby-link'

import './paragraph.css'

class Paragraph extends Component {

  render () {

    if (this.props.containsHTML) {
      return (
        <p
          style={this.props.style}
          className="paragraph-text"
          dangerouslySetInnerHTML={{__html: this.props.text}}>
        </p>
      );
    } else {
      return (
        <p
          style={this.props.style}
          className="paragraph-text">
          {this.props.text}
        </p>
      );
    }
  }
}


export default {Paragraph}



// WEBPACK FOOTER //
// ./src/components/Paragraph/index.js